import React from 'react';
import './GetStartedPage.css';
import Seo from "./components/Seo";

const GetStartedPage = () => {
    return (
        <div className="get-started-page">
            <Seo
                title="Get Started — Bring NYX NoCode to Your Classroom"
                description="Request access, schedule a demo, or launch a pilot. NYX NoCode is built for teachers and loved by students."
            />
            <header className="get-started-header">
                <h1>Get Started with NYX NoCode</h1>
            </header>

            <section className="form-section">
                <div className="google-form-container">
                    <iframe 
                        src="https://docs.google.com/forms/d/e/1FAIpQLSegyAcCDVQV2YIcCK0nvIGTBUsAGOTDWx_4PM6OLxVwwg4qSQ/viewform?embedded=true" 
                        style={{height: "2071px"}}
                        frameBorder="0" 
                        marginHeight="0" 
                        marginWidth="0"
                        title="NYX NoCode Get Started Form"
                    >
                        Loading…
                    </iframe>
                </div>
            </section>

            <section className="next-steps-section">
                <h2>What Happens Next?</h2>
                <div className="steps-grid">
                    <div className="step-item">
                        <div className="step-number">1</div>
                        <h3>We Review Your Request</h3>
                        <p>Our team will review your request and understand your classroom needs.</p>
                    </div>
                    <div className="step-item">
                        <div className="step-number">2</div>
                        <h3>Schedule a Consultation</h3>
                        <p>If needed, we'll reach out to discuss your goals and answer questions.</p>
                    </div>
                    <div className="step-item">
                        <div className="step-number">3</div>
                        <h3>Launch Your Program</h3>
                        <p>Get started with Free Educator Access, Demo Day, 3-Week NoCode Hackathon, ongoing classroom access, or teacher training.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GetStartedPage;